<div class="wrap">
  <div class="header">
    <h1>Clicotte</h1>
    <app-container-progress></app-container-progress>
  </div>

  <!-- <div class="filter">
    <form [formGroup]="containersFilterForm" (ngSubmit)="onSubmit()">
      <div class="createdOn">
        <label><strong>Date de création du container</strong></label>
        <div class="input_datePicker">
          <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input matInput [matDatepicker]="pickerCreatedOnFrom" formControlName="createdOnFrom">
            <mat-datepicker-toggle matSuffix [for]="pickerCreatedOnFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerCreatedOnFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input matInput [matDatepicker]="pickerCreatedOnTo" [min]="containersFilterForm.get('createdOnFrom').value"
              formControlName="createdOnTo">
            <mat-datepicker-toggle matSuffix [for]="pickerCreatedOnTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerCreatedOnTo></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="startedOn">
        <label><strong>Date de début du container</strong></label>
        <div class="input_datePicker">
          <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input matInput [matDatepicker]="pickerStartedOnFrom" formControlName="startedOnFrom">
            <mat-datepicker-toggle matSuffix [for]="pickerStartedOnFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartedOnFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input matInput [matDatepicker]="pickerStartedOnTo" [min]="containersFilterForm.get('startedOnFrom').value"
              formControlName="startedOnTo">
            <mat-datepicker-toggle matSuffix [for]="pickerStartedOnTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartedOnTo></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="btn_action">
        <fa-icon [icon]="faRedoAlt" (click)="resetFilter()"></fa-icon>
        <button type="submit">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      </div>


    </form>

  </div> -->

  <div class="container">
    <table mat-table [dataSource]="dataSource" matSort matPaginator class="mat-elevation-z8">
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOn" justify="end">Date de création</th>
        <td mat-cell *matCellDef="let element"> {{element.createdOn | date}} </td>
      </ng-container>
    
      <ng-container matColumnDef="weight"  >
        <th mat-header-cell *matHeaderCellDef mat-sort-header justify="end" [style.width.%]="10">Poids du camion (kg)</th>
        <td mat-cell *matCellDef="let element"[style.width.%]="10"> {{element.weight}}</td>
      </ng-container>
      <ng-container matColumnDef="supp" >
        <th mat-header-cell *matHeaderCellDef mat-sort-header justify="end" [style.width.%]="10">Supp.</th>
        <td mat-cell *matCellDef="let element" [style.width.%]="10">
          <fa-icon [icon]="faTrash" (click)="openDialogDeleteContainer(element.id)"></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"> </tr>

    </table>

    <div class="notResul" *ngIf="!dataSource.data.length">
      <p>Il n'y a pas de résultat</p>
    </div>

    <mat-paginator *ngIf="paginationRecords" [pageSize]="paginationRecords?.pageSize"
      [length]="paginationRecords?.totalRecords" [pageIndex]="paginationRecords?.pageNumber - 1"
      (page)="onPageRecordsChanged($event)" [hidePageSize]="true">
    </mat-paginator>

  </div>


</div>